export default __webpack_public_path__ + "static/media/Haley_Findlay_AHV_In_Moms_We_Trust.b58f7e65.jpg";